const VALUES = [
  {
    icon: "ri-emotion-happy-line",
    title: "免费畅读",
    desc: "连载与完结作品全部免费，大结局不设门槛，快乐阅读无需付费。",
  },
  {
    icon: "ri-image-line",
    title: "高清画质",
    desc: "高清原图加载，适配手机与平板，双指放大不糊帧。",
  },
  {
    icon: "ri-flashlight-line",
    title: "更新迅速",
    desc: "热门连载每周更新，第一时间同步最新话，追更不等待。",
  },
  {
    icon: "ri-shield-check-line",
    title: "健康内容",
    desc: "精选正能量作品，营造绿色、健康、向上的阅读社区。",
  },
];

export default function BrandStory() {
  return (
    <section className="container-site py-12 md:py-16" aria-labelledby="brand-title">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
        <div>
          <span className="chip-tag">品牌介绍</span>
          <h2 id="brand-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于89890漫画网
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
            89890漫画网创立于 2018 年，是一家专注于浪漫恋爱题材的漫画在线阅读平台。我们相信，好故事值得被更多人看见 ——
            因此从创立第一天起，我们就坚持「免费 + 高清 + 无门槛」的阅读理念。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
            从《青梅竹马不断向我甜蜜求婚》这样的热门完结作品，到每天更新的人气连载，我们为千万读者提供了
            1200+ 部风格各异的漫画，涵盖恋爱、校园、都市、甜宠、搞笑等全部分类，其中 500+ 部作品已完整上线大结局，随时畅读。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
            我们始终把读者体验放在第一位：清晰流畅的阅读器、精准的分类推荐、活跃的社区互动，以及一支响应迅速的运营团队，
            只为让每一次翻开漫画都成为愉快的体验。
          </p>
        </div>

        <div className="relative">
          <img
            src="https://readdy.ai/api/search-image?query=cozy%20illustration%20of%20young%20readers%20happily%20reading%20comic%20books%20on%20sofas%20and%20bean%20bags%20in%20a%20warm%20bright%20reading%20room%20with%20bookshelves%2C%20plants%20and%20warm%20lamp%20light%2C%20stylized%20flat%20anime%20illustration%20style%2C%20warm%20coral%20peach%20and%20cream%20color%20palette%2C%20cheerful%20relaxed%20atmosphere%2C%20high%20quality%20digital%20art%2C%20no%20text&width=900&height=650&seq=about-brand-89890&orientation=landscape"
            alt="89890漫画网 阅读空间插画"
            title="89890漫画网 阅读空间插画"
            className="w-full rounded-lg border border-background-200/70 object-cover"
          />
          <div className="absolute -bottom-4 left-6 flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 px-4 py-3 shadow-soft">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-lg text-primary-600">
              <i className="ri-heart-3-fill" aria-hidden="true" />
            </span>
            <div>
              <p className="font-heading text-lg font-bold leading-none text-foreground-950">860万+</p>
              <p className="mt-1 text-xs text-foreground-600">注册读者共同选择</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
        {VALUES.map((item) => (
          <div
            key={item.title}
            className="rounded-lg border border-background-200/70 bg-background-100/60 p-5 transition-colors hover:border-primary-300"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
              <i className={item.icon} aria-hidden="true" />
            </span>
            <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}